import styled from 'styled-components'
import { customTheme } from '../../styles/theme'

interface IFooterProps {
  $isOpen?: boolean;
}

interface IImageViewerProps {
  bg?: string;
}

export const Wrapper = styled.div`
  width: 100%;
  height: 90%;
  margin-top: 60px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    height: max-content;
    overflow: auto;
  }
`

export const Container = styled.div<any>`
  width: 63.5%;
  height: 90%;
  max-width: 90vw;
  max-height: 80%;
  margin-left: 17vw;
  position: relative;
  
  display: flex;
  align-items: center;
  justify-content: center;

  /* background: rgba(0, 0, 0, 0.42); */
  ${(props) => props.isintestingphase && `background-image: url(${props.img});`}
  ${(props) => props.isintestingphase && 'background-position: inherit;'}
  ${(props) => props.isintestingphase && 'background-size: cover;'}
  border: 1.84534px solid #D9D9D9;
  box-shadow: 0px 7.23636px 35.2773px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(20px);
  border-radius: 33px;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    flex-direction: column;
    width: 100%;
    margin: 70px 0 -30px;
    max-width: 100%;
    padding: 0 0 300px;
    margin-bottom: -250px;
  }
`

export const ImageViewer = styled.div<IImageViewerProps>`
  padding: 3px;
  width: 35%;
  height: 95%;
  
  position: absolute;
  left: -17vw;
  
  overflow: hidden;
  background: ${({ bg }) => bg || customTheme.colors.purple};
  border-radius: 20px;

  z-index: 99;
  /* position: relative; */

  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 20px;
  }

  @media (max-width: ${customTheme.breakpoints[1]}) {
    width: 65%;
    aspect-ratio: 260/315;
    height: unset;
    position: relative;
    margin-top: -25px;
    left: unset;
  }
`

export const ZoomWrapper = styled.button`
  position: absolute;
  top: 3%;
  right: 3%;

  background: none;
  border: none;
  cursor: pointer;
  background: #606372;
  height: 35px;
  width: 35px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding-left: 5vw;
  /* margin-left: -100px;
  padding: 15px 25px 15px 125px; */
  
  position: relative;
  z-index: 9;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;

  /* background: rgba(0, 0, 0, 0.42);
  border: 1.84534px solid #D9D9D9;
  box-shadow: 0px 7.23636px 35.2773px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(54.4375px);
  border-radius: 33px; */

  @media (max-width: ${customTheme.breakpoints[1]}) {
    margin: 0;
    width: 100%;
    padding: 15px;
  }
`

export const Content = styled.div<any>`
  width: 95%;
  height: 95%;
  overflow: auto;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-right: 10px;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    padding-right: 0;
  }

  & {
    scrollbar-width: thin;
    scrollbar-color: ${customTheme.colors.white} rgba(255,255,255, .19);
  }

  &::-webkit-scrollbar {
    border-radius: 20px;
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 20px;
    background-color: ${(props:any) => `${props.gamecolor}40`};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props:any) => props.gamecolor};
    border-radius: 20px;
  }
`

export const Footer = styled.div<IFooterProps>`
  position: absolute;
  bottom: -10vh;

  width: 100%;
  /* padding: 13px 80px 0px; */
  /* max-width: 95vw; */
  margin: 0 auto;

  opacity: ${({ $isOpen }) => $isOpen ? 1 : 0};
  
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    position: unset;
    padding: 0 20px;

    button {
      font-size: 16px;
      min-height: 50px;
    }
  }
`

export const Terms = styled.div`
  height: auto;
  margin-bottom: 10px;

  display: flex;
  align-items: flex-start;
  justify-content: center;

  margin: 10vh 0 -10vh;


  & > a {
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: ${customTheme.colors.white};
    cursor: pointer;
    z-index: 9;
    
    &:hover {
      text-decoration: underline;
    }

    & + a {
      margin-left: 15px;
    }
  }

  @media (max-width: ${customTheme.breakpoints[1]}) {
    display: none;
  }
`

export const MissionInfoWrapper = styled.div`
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 9;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    right: 10px;

    button {
      width: 35px;
      height: 35px;
      font-size: 24px;
    }
  }
`
export const MissionApprovalWrapper = styled.div`
  position: absolute;
  width: 100%;
  max-width: 90vw;
  top: 0;
  right: 0;
  z-index: 999;
`
